// extracted by mini-css-extract-plugin
export default {"container":"Intro_container__bLNUA","zoomInOut":"Intro_zoomInOut__JB6T9","read-more":"Intro_read-more__RK+RH","expandCollapse":"Intro_expandCollapse__xlbug"};